import { Component, ElementRef, OnInit } from '@angular/core';
import * as moment from 'moment';
import { PageBase, RentalInfo, RentalStatus, TurboHubEventType } from 't4core';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { NavigationService } from 'app-components';
import { ActiveRentalService } from 'app-components';
import { ExtendRentalComponent } from '../../Views/extend-rental/extend-rental.component';
import { LocationInfoComponent } from '../../dialogs/location-info/location-info.component';
import { TrailerInfoComponent } from '../../dialogs/trailer-info/trailer-info.component';
import { LayoutService } from 'app-components';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LocationAccessDialog } from '../../../Rental/dialogs/location-access/location-access';
import { ReturnFarAwayDialog } from '../../../Rental/dialogs/return-faraway/return-faraway';

@Component({
    selector: 'app-in-flight',
    templateUrl: './in-flight.component.html',
    styleUrls: ['./in-flight.component.css'],
    standalone: false
})
export class InFlightComponent extends PageBase implements OnInit {

    public booking: RentalInfo;
    public countdown: moment.Duration;
    public late: boolean = false;
  public hasLock: boolean = false;
  public allowUnmanned: boolean = false;
  public toFarAway: boolean = false;

    public lockOpen: boolean = false;

  constructor(el: ElementRef, private aviationService: NavigationService, private appSvc: AppIntegrationService, private rentalService: ActiveRentalService, private layoutService: LayoutService, private appSettings: AppSettingsService,) {
    super(el);
  }

  private notificationSub: Subscription;
    async ngOnInit() {
      this.booking = await this.rentalService.getBooking();
      this.init();

      ////If we extend, we update the cached rental Object to the correct Time.
      //if (this.aviationService.getParam('extended') && this.aviationService.getParam('rentalId')){
      //  this.rentalService.setActiveRental(parseInt(this.aviationService.getParam('rentalId')))
      //}

      this.notificationSub = this.rentalService.onRentalUpdated.pipe(filter(x => x == this.booking.Id)).subscribe(async x => {
        this.booking = await this.rentalService.getBooking();

        this.init();
      });
  }

  async ngOnDestroy() {
    if (this.notificationSub) this.notificationSub.unsubscribe();
  }

  private async init() {
    if (this.booking.Status == RentalStatus.Canceled) this.aviationService.executeCommand("Back");
    if (this.booking.Status < RentalStatus.Active) this.aviationService.executeCommand("ReversedRemotely");
    if (this.booking.Status > RentalStatus.Late) this.aviationService.executeCommand("ReturnedRemotely");

    this.hasLock = await this.rentalService.hasLock();
    this.allowUnmanned = await this.rentalService.allowUnmanned();
      this.late = this.booking.Status == RentalStatus.Late;
  }

    secondTick() {
        if (this.booking) {
            this.countdown = moment.duration(this.booking.ReturnTime.diff(moment()));
            if (this.countdown.asSeconds() <= 0) {
              this.late = true;
            }
        }
    }

  public recieveRentalAction(action: string):void {
    switch (action) {
      case "unlock": { this.unlock(); break; }
      case "extend": { this.extend(); break; }
      case "return": {
        this.return(); break;
      }
    }
  }

  public unlock(): void {
    this.aviationService.executeCommand("Unlock", { event: "Active" });
  }
  public extend(): void {
    this.aviationService.executeCommand("Extend", { rentalId: this.booking.Id });
  }
  public async return(): Promise<void> {
    var harTag = await this.rentalService.hasTag();

    // Pickup Device Info
    var userAgent = navigator.userAgent;
    const deviceInfo = userAgent.match(/\(([^)]+)\)/);
    this.booking.ReturnDevice = deviceInfo[1];

    this.Insights.logEvent("Return started", { isLockless: harTag.toString() , hasLock: this.hasLock.toString(), rentalId: this.booking.Id + "" });
    this.aviationService.executeCommand("Return", { event: "Return" });
  }

    public openDialog(): void {
        const dialogRef = this.Dialog.open(ExtendRentalComponent, {
            width: '350px',
            data: { bookingId: this.booking.Id, typeId: this.booking.PrimaryType.Id, locationId: this.booking.ReturnLocationId, pickupTime: this.booking.PickupTime, returnTime: this.booking.ReturnTime, selected: null }
        });

        dialogRef.afterClosed().subscribe(async result => {
            if (result) {
                this.booking = await this.rentalService.getBooking();
            }
        });
    }

    public openLocationInfoDialog(): void {
        const dialogRef = this.Dialog.open(LocationInfoComponent, {
            width: '350px',
            data:  this.booking.PickupLocation.Id
        });

        dialogRef.afterClosed().subscribe(async result => {
        });
    }

    public openTrailerInfoDialog(): void {
        const dialogRef = this.Dialog.open(TrailerInfoComponent, {
            width: '350px',
            data: this.booking.ObjectId
        });

        dialogRef.afterClosed().subscribe(async result => {
        });
  }
  public onToFarAwayChanged(value: boolean) {
    this.toFarAway = value;
  }
  public async sendRentalAction(action: string) {
    const requiredLocationCheck = ['start', 'return'].includes(action);
    const returnFarAway = ['return'].includes(action);
    if (requiredLocationCheck && this.appSvc.Device.Location < 3 && localStorage.getItem('atLocation') != "true") {
      const dialogRef = this.Dialog.open(LocationAccessDialog, {
        disableClose: true,
        width: '350px',
        position: { top: '50px' },
        data: { action }
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res === action) {
          this.return();
        } else {
          this.openSettings();
        }
      })
    }
    else if (returnFarAway && this.toFarAway) {
      const dialogRef = this.Dialog.open(ReturnFarAwayDialog, {
        disableClose: true,
        width: '350px',
        position: { top: '50px' },
        data: {
          location: this.booking.ReturnLocation?.Name,
          distance: await this.appSvc.getDistanceFromUser(this.booking.PickupLocation.TrailerPointLatitude, this.booking.PickupLocation.TrailerPointLongitude),
          trailerPointLatitude: this.booking.PickupLocation.TrailerPointLatitude,
          trailerPointLongitude: this.booking.PickupLocation.TrailerPointLongitude,
          cordinates: await this.appSvc.getCoordinates(),
          theme: this.appSettings.settings.theme
        }
      });
      dialogRef.afterClosed().subscribe(x => {
        if (x === action) {
          this.rentalService.flagRentalBooking(this.booking.Id);
          this.Insights.trackTrace("Set rental as flagged for returning away from trailer point");
          this.return();
        } else {
          return;
        }
      })
    }
    else {
      this.return();
    }

  }
  public openSettings() {
    this.Api.post<boolean>("/Rental/LogEvent", "Opened device settings to allow location services ", { rentalId: this.booking.Id });
    this.appSvc.openPermissions();
  }
}
